import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '10px',
        padding: '40px 16px',
        height: '100%',
    },
    icon: {
        fontSize: '48px',
    },
    message: {
        maxWidth: '600px',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
    },
}
